export default "__VITE_ASSET__6d586b0c__"